import { Content } from '../../types';

export const hanoiContent: Content = {
  title: 'האנוי - בירת וייטנאם, בין היסטוריה לתרבות',
  imageUrl: '/images/vietnam/hanoi/hanoi-wide.jpeg',
  introduction:
    "האנוי, בירת וייטנאם, הינה אחת הערים המרתקות ביותר בדרום-מזרח אסיה. בעבר שימשה כבירת צפון וייטנאם עד איחוד המדינה בשנת 1976, לאחר ניצחון הצפון בהנהגתו של הו צ'י מין על הדרום בתום מלחמת וייטנאם. כיום, האנוי הינה מרכז פוליטי, תרבותי וכלכלי, המאכלס למעלה מ-8 מיליון תושבים.\n\nהעיר ממוקמת על הגדה המערבית של הנהר האדום ומהווה שילוב ייחודי של היסטוריה, מסורת וקצב חיים מודרני. בין הסמטאות הציוריות של הרובע העתיק למבנים הקולוניאליים מתקופת השלטון הצרפתי, האנוי מציעה חוויה בלתי נשכחת לכל מבקר.",
  sections: [
    {
      title: 'אתרים מרכזיים בהאנוי',
      type: 'list',
      content: [
        {
          subtitle: 'הרובע העתיק (Old Quarter)',
          text: 'ליבה הפועם של האנוי, רובע תוסס עם רחובות צרים, חנויות מסורתיות ושווקים צבעוניים. זהו המקום הטוב ביותר להכיר את חיי הרחוב הווייטנאמים.',
        },
        {
          subtitle: 'אגם הואן קיאם (Hoan Kiem Lake)',
          text: 'נחשב לריאה הירוקה של העיר, מוקף בפארקים ומסלולי הליכה. בלב האגם נמצא מקדש נגוק סון (Ngoc Son Temple), המוקדש ללוחם דגול מההיסטוריה הווייטנאמית.',
        },
        {
          subtitle: "המאוזוליאום של הו צ'י מין",
          text: 'מבנה מרשים שבו שמורה גופתו החנוטה של מנהיג הצפון. האתר מהווה מוקד עלייה לרגל עבור המקומיים והתיירים כאחד.',
        },
        {
          subtitle: 'מקדש הספרות (Temple of Literature)',
          text: 'אחד האתרים ההיסטוריים המרשימים ביותר בעיר. המקדש נבנה בשנת 1070 לכבוד הפילוסוף קונפוציוס ושימש כאוניברסיטה הראשונה של וייטנאם.',
        },
        {
          subtitle: 'פגודת העמוד הבודד',
          text: 'פגודה קטנה ומיוחדת שנבנתה על עמוד אבן יחיד במאה ה-11. היא נחשבת לאחד הסמלים האייקוניים של העיר.',
        },
        {
          subtitle: 'המוזיאון הצבאי (Vietnam Military History Museum)',
          text: 'מציג את ההיסטוריה הצבאית של וייטנאם דרך כלי נשק, מטוסים ורכבים מתקופות שונות.',
        },
        {
          subtitle: 'בית האופרה של האנוי',
          text: 'מבנה קולוניאלי מרהיב שהוקם בתקופה הצרפתית ומשמש עד היום להופעות מוזיקליות ואירועי תרבות.',
        },
        {
          subtitle: 'בית הדואר המרכזי',
          text: 'מבנה מרשים נוסף מתקופת השלטון הצרפתי, המשלב אדריכלות אירופית קלאסית עם השפעות אסייתיות.',
        },
        {
          subtitle: 'בית הסוהר הואה לו (Hoa Lo Prison)',
          text: 'מכונה גם "הילטון האנוי", בית סוהר מתקופת הקולוניאליזם הצרפתי אשר שימש לכליאת מתנגדי משטר ובהמשך אסירים אמריקאים במהלך מלחמת וייטנאם.',
        },
        {
          subtitle: 'רחוב הרכבת (Train Street)',
          text: 'רחוב צר שבמרכזו עובר פס רכבת פעיל. מומלץ להגיע בשעות בהן הרכבת חולפת וליהנות מחוויית צפייה יוצאת דופן.',
        },
      ],
    },
    {
      title: 'שוק סוף השבוע והחוויה התרבותית',
      type: 'text',
      content:
        'בכל סוף שבוע, הרובע העתיק מארח את שוק סוף השבוע של האנוי, אשר מתקיים בימי שבת וראשון בערבים. השוק נפרס לאורך רחובות מרכזיים ומציע מבחר עצום של מוצרים - מבגדים ומזכרות ועד לאוכל רחוב וייטנאמי מסורתי.\n\nבנוסף, בסופי השבוע, חלקים מרכזיים בעיר, בעיקר סביב אגם הואן קיאם, נסגרים לתנועה והופכים למוקד תרבותי שוקק חיים. הרחובות מתמלאים במופעי רחוב, משחקים מסורתיים, הופעות מוזיקה חיה ואירועים מיוחדים, המספקים חוויה אותנטית וייחודית.',
    },
    {
      title: 'סיורי אוכל - חוויית טעמים בלתי נשכחת',
      type: 'text',
      content:
        "האנוי הינה גן עדן לחובבי קולינריה ואחד הדברים הפופולריים ביותר בקרב תיירים הוא סיור אוכל רחוב. ניתן למצוא סיורים מודרכים המתמקדים במנות מקומיות כמו:\n\nבאן מי (Banh Mi) - כריך צרפתי - וייטנאמי עם מרכיבים טריים.\nפו (Pho) - מרק האטריות המפורסם עם בקר או עוף.\nבונ צ'ה (Bun Cha) - מנת בשר חזיר צלוי מוגשת עם אטריות אורז ורוטב דגים.\nקפה ביצים (Ca Phe Trung) - משקה קפה ייחודי עם קציפת ביצה מתוקה.\n\nסיורים אלו מאפשרים לחוות את האנוי דרך החיך, לטעום מאכלים מסורתיים ולהכיר את התרבות המקומית דרך הסיפורים שמאחורי כל מנה.",
    },
    {
      title: 'תרבות הקפה בהאנוי',
      type: 'text',
      content:
        'האנוי מפורסמת בבתי הקפה הייחודיים שלה, המציעים מגוון רחב של סוגי קפה ודרכי הכנה מסורתיות. חלק מהקפה הווייטנאמי המפורסם כולל:\n\nקפה ביצים (Egg Coffee) - קפה חזק עם קציפת ביצה מתקתקה.\nקפה עם חלב מרוכז (Ca Phe Sua Da) - קפה קר עם חלב ממותק מרוכז, משקה פופולרי מאוד.\nקפה קוקוס (Ca Phe Cot Dua) - שילוב נהדר של קפה עם קרם קוקוס עשיר.\nקפה שוקולד ווניל - וריאציות מתוקות על קפה וייטנאמי מסורתי.\n\nבתי הקפה הפזורים ברחבי העיר מציעים אווירה ייחודית - מחצרות ירוקות נסתרות ועד למרפסות עם נוף מרהיב של העיר. חלקם משמרים עיצוב היסטורי וקולוניאלי והינם מהווים מקום נהדר להירגע וליהנות מהאווירה של האנוי.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, האנוי הינה עיר תוססת ועמוסת ניגודים, בה היסטוריה עתיקה משתלבת עם מודרניות מהירה. בין סמטאות הרובע העתיק, האגמים הפסטורליים והמבנים המפוארים, ניתן למצוא קסם מיוחד שמושך אליו מטיילים מכל רחבי העולם. עם שוק סוף השבוע הססגוני, סצנת האוכל העשירה ותרבות הקפה המיוחדת, האנוי מציעה חוויה תרבותית וקולינרית יוצאת דופן. בין אם הינכם חובבי היסטוריה, תרבות או קולינריה - האנוי מציעה חוויה עשירה ובלתי נשכחת.',
    },
  ],
};
